export default __webpack_public_path__ + "static/media/duplicate-icon.e9306eb6.svg";